<template>
  <div class="wrapper">
    <!-- Sidebar -->
    <div class="iq-sidebar sidebar-default">
      <div class="iq-sidebar-logo d-flex align-items-center justify-content-between">
        <router-link to="/" class="header-logo">
          <img src="assets/images/real-estate.png" class="img-fluid rounded-normal light-logo" alt="logo" />
          <h5 class="logo-title light-logo ml-3">Estate Rwanda</h5>
        </router-link>
        <div class="iq-menu-bt-sidebar ml-0">
          <i class="las la-bars wrapper-menu"></i>
        </div>
      </div>
      <div class="data-scrollbar" data-scroll="1">
        <nav class="iq-sidebar-menu">
          <ul id="iq-sidebar-toggle" class="iq-menu">
            <li :class="{ active: $route.name === 'DashboardItem' }">
              <router-link to="/" class="svg-icon">
                <svg
                  class="svg-icon"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                <span class="ml-4">Dashboard</span>
              </router-link>
            </li>
            <li :class="{ active: $route.name === 'AgentsItem' }">
              <router-link to="/agents" class="svg-icon">
                <svg
                  class="svg-icon"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span class="ml-4">Agent Management</span>
              </router-link>
            </li>
            <li :class="{ active: $route.name === 'PropertiesItem' }">
              <router-link to="/properties" class="svg-icon">
                <svg
                  class="svg-icon"
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <span class="ml-4">Property Management</span>
              </router-link>
            </li>
          </ul>
        </nav>
        <div id="sidebar-bottom" class="position-relative sidebar-bottom">
          <div class="card border-none">
            <div class="card-body p-0">
              <div class="sidebarbottom-content">
                <div class="image">
                  <img src="assets/images/layouts/side-bkg.png" class="img-fluid" alt="side-bkg" />
                </div>
                <h6 class="mt-4 px-4 body-title">
                  Need Professional website call Tamba Group +250 789 326 245
                </h6>
                <button type="button" class="btn sidebar-bottom-btn mt-4">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3"></div>
      </div>
    </div>

    <!-- Top Navbar -->
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <div class="iq-navbar-logo d-flex align-items-center justify-content-between">
            <i class="ri-menu-line wrapper-menu"></i>
            <router-link to="/dashboard" class="header-logo">
              <img src="assets/images/logo.png" class="img-fluid rounded-normal" alt="logo" />
              <h5 class="logo-title ml-3">Tamba Estate Admin</h5>
            </router-link>
          </div>
          <div class="iq-search-bar device-search">
            <form action="#" class="searchbox">
              <a class="search-link" href="#"><i class="ri-search-line"></i></a>
              <input type="text" class="text search-input" placeholder="Search here..." />
            </form>
          </div>
          <div class="d-flex align-items-center">
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-label="Toggle navigation"
            >
              <i class="ri-menu-3-line"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto navbar-list align-items-center">
                <li class="nav-item nav-icon dropdown caption-content">
                  <a
                    href="#"
                    class="search-toggle dropdown-toggle"
                    id="dropdownMenuButton4"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src="assets/images/user/1.png" class="img-fluid rounded" alt="user" />
                  </a>
                  <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div class="card shadow-none m-0">
                      <div class="card-body p-0 text-center">
                        <div class="media-body profile-detail text-center">
                          <img
                            src="assets/images/page-img/profile-bg.jpg"
                            alt="profile-bg"
                            class="rounded-top img-fluid mb-4"
                          />
                          <img
                            src="assets/images/user/1.png"
                            alt="profile-img"
                            class="rounded profile-img img-fluid avatar-70"
                          />
                        </div>
                        <div class="p-3">
                          <h5 class="mb-1">{{ user?.email || 'Loading...' }}</h5>
                          <p class="mb-0">Since May 12, 2025</p>
                          <div class="d-flex align-items-center justify-content-center mt-3">
                            <router-link to="/profile" class="btn border mr-2">Profile</router-link>
                            <a href="#" class="btn border" @click.prevent="handleLogout">Sign Out</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>

    <!-- Content -->
    <div class="content-page">
      <div v-if="loading" class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <router-view v-else name="dashboard"></router-view>
    </div>

    <!-- Footer -->
    <footer class="iq-footer">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item"><a href="#">Privacy Policy</a></li>
                  <li class="list-inline-item"><a href="#">Terms of Use</a></li>
                </ul>
              </div>
              <div class="col-lg-6 text-right">
                <span class="mr-1">2025 © </span>
                <a href="#" class="">Tamba Group</a>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import apiClient from '../services/api'
import type { User, ApiError } from '../types'

const router = useRouter()
const route = useRoute()
const user = ref<User | null>(null)
const loading = ref(true)

onMounted(async () => {
  try {
    const response = await apiClient.get<User>('/auth/me')
    user.value = {
      id: response.data.id,
      name: response.data.name,
      email: response.data.email,
      role: response.data.role
    }
  } catch (err: any) {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authUser')
    router.push('/login')
  } finally {
    loading.value = false
  }
})

const handleLogout = async () => {
  try {
    await apiClient.post('/auth/logout')
  } catch (err) {
    // Proceed with logout even if API call fails
  } finally {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authUser')
    router.push('/login')
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.iq-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100%;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
.iq-top-navbar {
  margin-left: 260px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
}
.content-page {
  margin-left: 260px;
  padding: 80px 20px 20px;
  flex: 1;
}
.iq-footer {
  margin-left: 260px;
  background: #f8f9fa;
  padding: 10px 0;
}
@media (max-width: 991px) {
  .iq-sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .iq-top-navbar,
  .content-page,
  .iq-footer {
    margin-left: 0;
  }
}
.spinner-border {
  width: 2rem;
  height: 2rem;
  margin-top: 2rem;
}
</style>
